// extracted by mini-css-extract-plugin
export var chip = "_em-0";
export var filterDropdown = "_em-5";
export var filterItem = "_em-6";
export var icon = "_em-1";
export var removeButton = "_em-3";
export var removeIcon = "_em-4";
export var separator = "_em-2";